package pwgs.ui.scenes.playerscene

import kotlinx.serialization.Serializable
import visage.ds.forms.FieldModel
import visage.ds.forms.MetaFieldModel
import visage.ds.forms.SelectOption
import visage.rmi.VisageController

@VisageController(PlayerSceneProps::class, PlayerSceneModel::class)
interface PlayerScene {
    fun load()
    fun ban()
    fun unban()
}

@Serializable
class PlayerSceneProps(
    val projectId: Long,
    val playerId: String
)

@Serializable
class PlayerSceneModel(
    val name: String,
    val isBanned: Boolean,
    val bannedUntil: String
) {
    var isLoading: Boolean = true
    var error: String? = null
    val banReason = FieldModel("")
    val banInterval = FieldModel("1")
    val banIntervalType = MetaFieldModel("Hours", listOf(
        SelectOption("Minutes", "Minutes"),
        SelectOption("Hours", "Hours"),
        SelectOption("Days", "Days"),
        SelectOption("Weeks", "Weeks"),
        SelectOption("Months", "Months"),
        SelectOption("Years", "Years"),
    ))
}

@Serializable
enum class EIntervalType {
    Minutes,
    Hours,
    Days,
    Weeks,
    Months,
    Years
}